import React from 'react';
import { Field } from 'redux-form'; // imported Field

//Controls
import Controls from 'utils/renderControl.js';

import { normalizePhone } from 'utils/normalize.js';

//States
import States from 'utils/states.js';

//STATELESS FUNCTION TO RENDER HISTORY FIELD ARRAY
const renderEmploymentHistory = (config, { fields }) => (
  <div className="history-record-list">
    {fields.map((member, index) => (
      <div className="history-record" key={index}>
        {/************************
         * COMPANY/PHONE/START/END DATE
         *************************/}
        <div className="row">
          <Field
            name={`${member}.company`}
            type="text"
            component={Controls.input}
            label="Company"
            wrapperClassName="col-sm-4"
          />
          <Field
            name={`${member}.phone`}
            type="text"
            component={Controls.input}
            normalize={normalizePhone}
            label="Telephone Number"
            placeholder="(xxx) xxx-xxxx"
            wrapperClassName="col-sm-4"
          />
          <Field
            name={`${member}.startDate`}
            component={Controls.date}
            label="Start Date"
            placeholder="Start Date"
            wrapperClassName="col-sm-2 date"
          />
          <Field
            name={`${member}.endDate`}
            type="date"
            component={Controls.date}
            label="End Date"
            placeholder="End Date"
            wrapperClassName="col-sm-2 date"
          />
        </div>

        {/************************
         * ADDRESS
         *************************/}
        <div className="row">
          <div className="col-sm-12">
            <label>Address</label>
          </div>
        </div>
        <div className="row">
          <Field
            name={`${member}.streetAddress`}
            type="text"
            component={Controls.input}
            label="Street"
            hideLabel={true}
            wrapperClassName="col-sm-4"
          />
          <Field
            name={`${member}.city`}
            type="text"
            component={Controls.input}
            label="City"
            hideLabel={true}
            wrapperClassName="col-sm-4"
          />
          <Field
            name={`${member}.state`}
            wrapperClassName="col-sm-2"
            hideLabel={true}
            component={Controls.select}
            label="State"
          >
            {States.map(state => (
              <option key={state.abbreviation} value={state.abbreviation}>
                {state.name}
              </option>
            ))}
          </Field>
          <Field
            name={`${member}.zipCode`}
            type="text"
            wrapperClassName="col-sm-2"
            hideLabel={true}
            component={Controls.input}
            label="Zip Code"
          />
        </div>

        {/************************
         * POSITION
         *************************/}
        <div className="row">
          <Field
            name={`${member}.position`}
            type="text"
            component={Controls.input}
            label="Position"
            wrapperClassName="col-sm-4"
          />
          {config.askAboutWages && (
            <Field
              name={`${member}.startingWage`}
              moneyField={true}
              component={Controls.input}
              label="Starting Wage"
              wrapperClassName="col-sm-2"
              placeholder="$00.00 / hr"
            />
          )}
          {config.askAboutWages && (
            <Field
              name={`${member}.endingWage`}
              moneyField={true}
              component={Controls.input}
              label="Ending Wage"
              wrapperClassName="col-sm-2"
              placeholder="$00.00 / hr"
            />
          )}

          <Field
            name={`${member}.currentEmployer`}
            component={Controls.booleanRadio}
            notInline={true}
            label="Current Employer?"
            wrapperClassName="col-sm-4 current"
          />
        </div>

        {/************************
         * DUTIES (lol...doody)
         *************************/}
        <div className="row">
          <Field
            name={`${member}.majorDuties`}
            type="text"
            component={Controls.textarea}
            label="Major Duties"
            placeholder=" "
            wrapperClassName="col-sm-12"
          />
        </div>

        {/************************
         * Reason for leaving
         *************************/}
        <div className="row">
          <Field
            name={`${member}.reasonForLeaving`}
            type="text"
            component={Controls.textarea}
            label="Reason for Leaving"
            placeholder=" "
            wrapperClassName="col-sm-12"
          />
        </div>

        {/************************
         * SUPERVISOR
         *************************/}
        <div className="row">
          <Field
            name={`${member}.supervisor`}
            type="text"
            component={Controls.input}
            label="Supervisor"
            wrapperClassName="col-sm-4"
          />

          <Field
            name={`${member}.canContactEmployer`}
            component={Controls.booleanRadio}
            label="May we contact this employer?"
            wrapperClassName="col-sm-8 employer-contact"
          />
        </div>
      </div>
    ))}
    <div className="add-remove-jobs">
      <button
        type="button"
        className="btn btn-default"
        onClick={() => {
          if (confirm('Are you sure you want to remove the last company?')) {
            fields.pop();
          }
        }}
      >
        Remove Job
      </button>
      <button type="button" className="btn btn-primary" onClick={() => fields.push({})}>
        Add a Job
      </button>
    </div>
  </div>
);

export default renderEmploymentHistory;
